import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import SEO from "../components/SEO";

const Contact = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    // Replace these with your actual IDs from the EmailJS Dashboard
    const SERVICE_ID = "service_06y3ige";
    const TEMPLATE_ID = "template_qppbmg9";
    const PUBLIC_KEY = "altBdAVzp94T4zdJO";

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY).then(
      () => {
        setLoading(false);
        setStatus({
          type: "success",
          message: "Thank you! Your message has been sent successfully.",
        });
        formRef.current.reset(); // Clear form
      },
      (error) => {
        setLoading(false);
        setStatus({
          type: "error",
          message:
            "Something went wrong. Please try again or email us directly.",
        });
        console.error("EmailJS Error:", error);
      },
    );
  };

  return (
    <div className="pt-32 pb-20 max-w-3xl mx-auto px-4">
      <SEO
        title="Contact Us | ACF Luxury Stays"
        description="Have questions about our luxury rentals? Contact the ACF team today."
        url="/contact"
      />

      <div className="text-center mb-12">
        <h1 className="text-4xl font-primary text-acf-blue mb-4">
          Contact ACF Luxury Stays
        </h1>
        <p className="font-secondary text-gray-600">
          Whether you're a guest or property owner, we're here to help.
        </p>
      </div>

      <div className="bg-white shadow-lg p-8 border-t-4 border-acf-gold">
        {status.message && (
          <div
            className={`mb-6 p-4 text-sm font-secondary ${
              status.type === "success"
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
            }`}
          >
            {status.message}
          </div>
        )}

        <form ref={formRef} onSubmit={handleSubmit}>
          <div className="grid md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="block font-primary text-acf-blue text-xs uppercase tracking-wide mb-2">
                First Name
              </label>
              <input
                name="first_name" // Match your EmailJS Template variable
                type="text"
                required
                className="w-full border-b-2 border-gray-200 focus:border-acf-gold outline-none py-2 font-secondary"
              />
            </div>
            <div>
              <label className="block font-primary text-acf-blue text-xs uppercase tracking-wide mb-2">
                Last Name
              </label>
              <input
                name="last_name"
                type="text"
                required
                className="w-full border-b-2 border-gray-200 focus:border-acf-gold outline-none py-2 font-secondary"
              />
            </div>
          </div>
          <div className="mb-6">
            <label className="block font-primary text-acf-blue text-xs uppercase tracking-wide mb-2">
              Email Address
            </label>
            <input
              name="email"
              type="email"
              required
              className="w-full border-b-2 border-gray-200 focus:border-acf-gold outline-none py-2 font-secondary"
            />
          </div>
          <div className="mb-8">
            <label className="block font-primary text-acf-blue text-xs uppercase tracking-wide mb-2">
              Message
            </label>
            <textarea
              name="message"
              rows="4"
              required
              className="w-full border-b-2 border-gray-200 focus:border-acf-gold outline-none py-2 font-secondary"
            ></textarea>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-acf-blue text-white py-3 font-primary uppercase tracking-widest hover:bg-acf-gold transition duration-300 disabled:opacity-50"
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
